module.exports = __webpack_public_path__ + "img/scanning.a64d6063.png";